import { getConfig } from '../config';

const accesstoken = localStorage.getItem("accesstoken");

export const api_config = async () => {
  try {
    console.log(process.env.NODE_ENV)
    // let endpoint = process.env.NODE_ENV === "development" ? "https://festaria-mypage.dev.upbond.io" : process.env.REACT_APP_API_BASE_URL;
    let endpoint = process.env.REACT_APP_API_BASE_URL;
    const auth_data = await getConfig();
    const api_auth = {
      mypage_host: endpoint,
      wallet_host: "https://nft-wallet.dev.upbond.io",
      config: {
        headers: {
          Authorization: "Bearer " + accesstoken,
          "X-origin": `${auth_data.configJson.domain}/`
        }
      },
      account: `${auth_data.configJson.account}`,
      aud: `${auth_data.configJson.client_id}`,
      iss: `${auth_data.configJson.domain}`,
    }

    if (accesstoken) {
      api_auth.config.headers = {
        Authorization: "Bearer " + accesstoken,
        "X-origin": `${auth_data.configJson.domain}/`,
    };

}
    return api_auth
  } catch(err) {
    console.log(err);
  }
}

export const reservation_config = {
  // TODO: Temp code for reservation feature
  api: 'https://api.dev.upbond.io',
  config: {
    headers: {
      account: 'e33381a0',
    }
  }
}

// export coonst warranty_config = async () =>{
//   const config = await getConfig();
//   const warrantyService = config.configJson.services.filter(x => x.name === "Warranty")?.[0];
// }
/**
 * MyPage 用 API（ポイント・購買履歴・品質保証書）の接続設定
 *
 * 以前はレガシー Basic 認証の資格情報をここに埋め込み、/Point/UserBalancePoint 等を
 * 任意の userId で呼んでいたが、ブラウザから資格情報が読めてしまうため廃止した。
 * 現在はログイン中ユーザーのアクセストークン（/profile と同じ）でバックエンドの
 * /api/mypage/* を呼び、対象ユーザーはサーバー側でトークンから決まる。
 */
export const mypage_api_config = async () => {
  const auth = await api_config();
  const host = String(auth?.mypage_host || '').replace(/\/+$/, '');
  // モジュール読み込み時ではなく呼び出し時のトークンを使う（ログイン直後・再ログイン後も最新にする）
  const token = localStorage.getItem("accesstoken");
  return {
    endpoints: {
      balance_url: `${host}/api/mypage/points/balance`,
      history_url: `${host}/api/mypage/points/history`,
      redeem_url: `${host}/api/mypage/points/redeem`,
      purchases_url: `${host}/api/mypage/purchases`,
      guarantee_cards_url: `${host}/api/mypage/guarantee-cards`,
    },
    config: {
      headers: {
        ...(auth?.config?.headers || {}),
        Authorization: "Bearer " + token,
      },
    },
  };
}

export const queryParam = (params) => {
  return Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");
};